import { Skeleton } from 'antd';
import React, { FC, useCallback, useState } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { useTranslation } from 'hooks/use-translation';
import { Label } from '../styles';

const Container = styled.div.attrs({ id: 'zap-container' })`
  .zap-row {
    border: none;
    border-bottom: 1px solid var(--gray-20);
    border-radius: 0;
    margin-bottom: 0px;
    height: 64px;
  }

  .zap-row:hover {
    background-color: var(--coolest-gray-20);
  }

  .zap-services {
    width: 100px;
  }

  .zap-description {
    padding: 0 20px;
  }

  .zap-power-bar {
    display: none;
  }

  .zap-button {
    display: none;
    border-radius: 0;
    border-color: var(--blue-60);
    font-weight: normal;
    height: 32px;
  }

  .zap-button:hover {
    background-color: transparent;
    box-shadow: none;
    color: var(--blue-60);
  }

  .zap-row:hover .zap-button {
    display: inline-flex;
  }
`;

export const ZapList: FC = () => {
  const [loading, setLoading] = useState(true);
  const heading = useTranslation('settings.integration.zapier.zaps.title');

  const onZapScriptLoad = useCallback(() => {
    requestAnimationFrame(() => setLoading(false));
  }, []);

  const handleScriptInject = ({ scriptTags = [] as HTMLScriptElement[] }) => {
    const zapScript: HTMLScriptElement | undefined = scriptTags.find(
      (_script) => _script.id === 'rl-zapier-widget',
    );

    if (zapScript) {
      zapScript.onload = onZapScriptLoad;
    }
  };

  return (
    <>
      <Helmet
        script={[
          {
            id: 'rl-zapier-widget',
            src: 'https://zapier.com/partner/legacy-widget-upgrade.js?services=rocketlane&html_id=zap-container&buttonType=outline',
          },
        ]}
        // Helmet doesn't support `onload` in script objects so we have to hack in our own
        // ref: https://github.com/nfl/react-helmet/issues/146#issuecomment-271552211
        onChangeClientState={(newState, addedTags) =>
          handleScriptInject(addedTags)
        }
      />
      <Label>{heading}</Label>
      <Container />
      <Skeleton paragraph={{ rows: 6 }} active loading={loading} />
    </>
  );
};
